<template>
    <v-container>
        <AccountHeader
                :settings="accountSetting" />
        <v-row>
            <v-col cols="12">
                <span>Submission time: {{ repliedAt }}</span>
            </v-col>
            <v-col cols="12">
                <v-card>
                    <v-card-title>Contact details</v-card-title>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-subtitle>First name</v-list-item-subtitle>
                            <v-list-item-title>{{ consumer.first_name }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-subtitle>Last name</v-list-item-subtitle>
                            <v-list-item-title>{{ consumer.last_name }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-subtitle>Email</v-list-item-subtitle>
                            <v-list-item-title>{{ consumer.email }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-subtitle>Phone</v-list-item-subtitle>
                            <v-list-item-title>{{ consumer.phone }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>{{ form.title }}</v-card-title>
                    <FieldReply
                            v-for="(item, itemKey) in reply"
                            :key="itemKey"
                            :reply="item" />
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import AccountHeader from "../AccountHeader";
    import FieldReply from "./components/FieldReply";

    export default {
        name: "ReplyComponent",
        components: {FieldReply, AccountHeader},
        data() {
            return {
            }
        },
        computed: {
            repliedAt() {
                return this.$store.forms.getRepliedAt();
            },
            reply() {
                return this.$store.forms.getReply();
            },
            form() {
                return this.$store.forms.getForm();
            },
            consumer() {
                return this.$store.forms.getConsumer();
            },
            accountSetting() {
                return this.$store.forms.getAccountSetting();
            },
            documentTitle() {
                return 'Response | ' + this.form.title || 'Response preview'
            }
        },
        watch: {
            documentTitle(val) {
                document.title = val;
            }
        },
        created() {
            const loading = this.$services.modals.loading.show('Loading response');
            this.$store.forms.loadReply(this.$route.params.replyId).catch(() => {
                this.$services.modals.alerts.error('Server error. Try again later');
            }).finally(() => {
                loading.hide();
            })
        }
    }
</script>

<style scoped>

</style>